
<Modal :show="show" :title="modalTitle" size="small" @onModalClose="handleClose">
    <div v-if="shift" class="shift-comments-modal">
        <div class="shift-info">
            <span class="info-item">
                <span class="label">Fahrer:</span>
                <span class="value">{{ driverName }}</span>
            </span>
            <span class="info-item">
                <span class="label">Schicht:</span>
                <span class="value">{{ shift.sequenceNumber || 'N/A' }}</span>
            </span>
            <span class="info-item">
                <span class="label">Kennzeichen:</span>
                <span class="value">{{ shift.licenseNumber || 'N/A' }}</span>
            </span>
            <span v-if="concession" class="info-item">
                <span class="label">Konzession:</span>
                <span class="value">{{ concession }}</span>
            </span>
        </div>
        <Comment
            :key="commentKey"
            resource-type="shifts"
            :resource-uuid="shiftUuid"
            :margin-top="1"
        />
    </div>
</Modal>
